import { useTagSettings } from '../frameworkAppSettings/useTagSettings';
import { useHasTags } from '../user/useHasTags';
export const useTagPropertyName = () => {
  const objectHasTags = useHasTags();
  const tagSettings = useTagSettings();
  if (!objectHasTags || !tagSettings) {
    return undefined;
  }
  return tagSettings.propertyName.value;
};